import { GritOverlay } from '../grit-overlay';
import {
  Directive,
  HostBinding,
  Input,
  ElementRef,
  OnChanges,
  OnInit,
  Optional,
  SimpleChanges,
  HostListener,
} from '@angular/core';
import { GritOverlayRef } from '../grit-overlay-ref';

@Directive({
  selector: '[grit-overlay-title], grit-overlay-title, [gritOverlayTitle]',
  exportAs: 'gritOverlayTitle',
})
export class GritOverlayTitleDirective {
  @HostBinding('class.grit-overlay-title') titleClass = true;
  _isSticky: boolean = true;
  @Input('sticky') get sticky() {
    return this._isSticky;
  }

  set sticky(sticky) {
    this._isSticky = sticky;
  }
}

@Directive({
  selector: '[grit-overlay-footer], grit-overlay-footer, [gritOverlayFooter]',
  exportAs: 'gritOverlayFooter',
})
export class GritOverlayFooterDirective {
  @Input('sticky') get sticky() {
    return this._isSticky;
  }

  set sticky(sticky) {
    this._isSticky = sticky;
  }

  _isSticky: boolean = false;

  @HostBinding('class.grit-overlay-footer') footerClass = true;
}

@Directive({
  selector: '[gritOverlayClose]',
  exportAs: 'gritOverlayClose',
})
export class GritOverlayCloseDirective implements OnInit, OnChanges {
  @Input('aria-label') ariaLabel: string;

  @Input('gritOverlayClose') _gritOverlayClose: any;

  @HostListener('click', ['$event.target'])
  onclick(event) {
    this.overlayRef.close(this._gritOverlayClose);
  }

  @HostBinding('attr.aria-label') _arialabel = this.ariaLabel || null;
  @HostBinding('type') _type = 'button';

  constructor(
    @Optional() public overlayRef: GritOverlayRef<any>,
    private _elementRef: ElementRef<HTMLElement>,
    private _overlay: GritOverlay
  ) {}

  ngOnInit() {
    if (!this.overlayRef) {
      this.overlayRef = getClosestOverlay(
        this._elementRef,
        this._overlay.openOverlays
      )!;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const proxiedChange = changes['_gritOverlayClose'];
    if (proxiedChange) {
      this._gritOverlayClose = proxiedChange.currentValue;
    }
  }
}

function getClosestOverlay(
  element: ElementRef<HTMLElement>,
  openOverlays: GritOverlayRef<any>[]
) {
  let parent: HTMLElement | null = element.nativeElement.parentElement;

  while (parent && !parent.classList.contains('grit-overlay-container')) {
    parent = parent.parentElement;
  }

  return parent
    ? openOverlays.find(overlay => overlay.id === parent!.id)
    : null;
}
